import React, {useEffect} from "react";
import MaterialTable from 'material-table';

// reactstrap components
import {
  Row,
  Col  
} from "reactstrap";

// style
import "assets/css/loading.css";
import {table_translate, table_style} from "constants/MaterialTable.js";

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";

// views
import UsuarioForm from "./UsuarioForm.jsx";

export default function UsuarioLista() {

    const [permiteEditar, set_permiteEditar] = React.useState(false);
    const [showLoading, setshowLoading] = React.useState(false);
    const [showDetail, set_showDetail] = React.useState(false);
    const [rowEdit, set_rowEdit] = React.useState(null);
    const [list_table, set_list_table] = React.useState([]);

    const handleAdd = () => {
        set_rowEdit(null);
        set_showDetail(true);
    }

    const handleEdit = (rowData) => {      
        set_rowEdit(rowData);
        set_showDetail(true);
    }

    const handleReturn = () => {
        set_rowEdit(null);
        set_showDetail(false);
        loadList();
    }

    const loadList = () => {
        setshowLoading(true);
        api_GET('usuario').then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else{
                set_list_table(result.data);
            }
        });      
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("Usuarios.Editar", function(result){set_permiteEditar(result)});      
        loadList();
    }, []);
    
    return (
        <>
        {showLoading && 
          <div className="carregandoCmp">
              <div className="box">                
                <img src={require("assets/img/loading.gif")}></img>
              </div>
          </div> 
        }
        {!showDetail &&
            <div className="content">
                <Row>
                    <Col md="12">
                    <button type="submit" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Novo Usuário</button>
                        <MaterialTable style={{minHeight:"auto"}}
                        title=""

                        columns={[
                            { title: 'Login', field: 'login'},
                            { title: 'Nome', field: 'nome'},                            
                            { title: 'Email', field: 'email' },
                            { title: 'Perfil', field: 'perfil.descricao' },
                            { title: 'Status', field: 'status' }
                        ]}
                        data={list_table}
                        isLoading={false}
                        options={{
                            ...table_style,
                            filtering: false,
                            exportButton: true
                        }}
                        actions={[
                            {
                            icon: 'edit',
                            tooltip: 'Editar Registro',
                            onClick: (event, rowData) => handleEdit(rowData)
                            }
                        ]}
                        localization={table_translate}
                        />
                    </Col>
                </Row>
            </div>
        }
        {showDetail &&
            <UsuarioForm item={rowEdit} handleReturn={handleReturn}></UsuarioForm>
        }
        </>
    );
}